/* eslint-disable no-console */
import {
  AgeGateDocument,
  App,
  CrmModalDocument,
  FooterDocument,
  Store as GCStore,
  LocationBannerAlertDocument,
  MinZipByCode,
  NavigationDocument,
  PromoCarouselDocumentData,
  SettingsDocumentData,
  ShoppingCartDocumentData,
  SideNavigationDocument,
  StorelocatorPageDocumentData,
  StoreSelectorDocumentData,
  TreezStore,
} from '@/types';

import data from './../public/ssr-cache.json';
import { SSR_CACHE_SCHEMA_VERSION, SSR_CACHE_TAG } from '@/constants';
import type { EnrichedHeaderDocument, StoreProductCard } from '@/types';

const reverseProxyLink = process.env.NEXT_PUBLIC_REVERSE_PROXY_LINK ?? '';

export interface IStoreMetadata {
  schemaVersion?: number;
  apps: App[];
  treezStores: TreezStore[];
  ageGate: AgeGateDocument;
  crm: any;
  crmModal: CrmModalDocument;
  footer: FooterDocument;
  header: EnrichedHeaderDocument;
  promotion: LocationBannerAlertDocument;
  navigation: NavigationDocument;
  sideNavigation: SideNavigationDocument;
  store: GCStore;
  promoCarousel: PromoCarouselDocumentData;
  /** Document product (CMS) enriched: `activeProduct`, `displayProps`, etc. */
  productCard: StoreProductCard;
  shoppingCart: ShoppingCartDocumentData;
  storeSelector: StoreSelectorDocumentData;
  storeLocator: StorelocatorPageDocumentData;
  metafield: any; // deprecated
  minZipByCode: MinZipByCode; // deprecated
  settings: SettingsDocumentData;
}

/**
 * This func return all the static data the website need
 * to function
 *
 */
export async function GetStoreMetadata(): Promise<IStoreMetadata> {
  const isBuilding = process.env.NEXT_PHASE === 'phase-production-build';
  const apiEndpoint = process.env.VERCEL_PROJECT_PRODUCTION_URL
    ? `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
    : 'http://localhost:3000';

  if (isBuilding) {
    console.info('[INFO] return data from local cache');
    return data as unknown as IStoreMetadata;
  }

  try {
    const r = await fetch(
      `${apiEndpoint}${reverseProxyLink}/api/ssr-cache?schema=${SSR_CACHE_SCHEMA_VERSION}`,
      {
        next: { tags: [SSR_CACHE_TAG] },
        cache: 'force-cache',
      },
    );

    if (!r.ok) {
      console.info('[INFO] return data from local cache');
      return data as unknown as IStoreMetadata;
    }

    const cache = (await r.json()) as IStoreMetadata;

    if (cache?.schemaVersion !== SSR_CACHE_SCHEMA_VERSION) {
      console.info(
        '[INFO] Schema version mismatch, return data from local cache',
      );
      return data as unknown as IStoreMetadata;
    }

    console.info('[INFO] return data from network request');

    return cache;
  } catch (err) {
    console.info('[INFO] return data from local cache', err);
    return data as unknown as IStoreMetadata;
  }
}
